module.exports = __webpack_public_path__ + "img/v1.7.83215c44.png";